<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div
      class="modal fade"
      id="admins-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">Admins Columns</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <!-- <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user-scan"></i>
                        <span class="custom-option-title"> Photo </span>
                      </span>
                      <input
                        class="form-check-input"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div> -->
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user"></i>
                        <span class="custom-option-title">
                          {{ $t("admins.first_name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.first_name.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user"></i>
                        <span class="custom-option-title">{{
                          $t("admins.last_name")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.last_name.enabled"
                        @change="updateColumns"
                        value=""
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-at"></i>
                        <span class="custom-option-title">{{
                          $t("admins.email")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.email.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password"></i>
                        <span class="custom-option-title">{{
                          $t("admins.password")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.password.enabled"
                        @change="updateColumns"
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-phone"></i>
                        <span class="custom-option-title">{{
                          $t("admins.phone")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.phone.enabled"
                        @change="updateColumns"
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-caret-left"></i>
                        <span class="custom-option-title">{{
                          $t("admins.prefix")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.prefix.enabled"
                        @change="updateColumns"
                        value=""
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-manual-gearbox"></i>
                        <span class="custom-option-title">{{
                          $t("admins.privileges")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.privleges.enabled"
                        @change="updateColumns"
                        value=""
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Anases"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-network"></i>
                        <span class="custom-option-title">{{
                          $t("admins.allowed_nases")
                        }}</span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.allowed_nases.enabled"
                        @change="updateColumns"
                        id="Anases"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Aprofile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("admins.allowed_profiles") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.allowed_profiles.enabled"
                        @change="updateColumns"
                        id="Aprofile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Aprofile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("admins.connection_status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        v-model="columns.connection_status.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <adminsAdd
      v-if="showAddAdmin && hasPrivilege('admins_edit_admins')"
      @updated="
        showAddAdmin = false;
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    v-if="hasPrivilege('admins_edit_admins')"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    @click="showAddAdminDialog"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("admins.add_admin") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    type="button"
                    v-if="hasPrivilege('reports_print')"
                    :disabled="!this.$store.getters.settings.license.active"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i>Print</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i>Csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-export me-2"></i>Excel</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i>Pdf</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    v-model="filters.search_query"
                    @change="applyFilters"
                    v-if="hasPrivilege('admins_view_search_admins')"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#admins-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>
            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="DataTables_Table_0"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('admins_delete_admins')">
                            <button
                              class="dropdown-item text-danger"
                              @click="groupDelete()"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting">{{ $t("admins.photo") }}</th>
                    <th class="sorting" v-if="columns.first_name.enabled">
                      {{ $t("admins.first_name") }}
                    </th>
                    <th class="sorting" v-if="columns.last_name.enabled">
                      {{ $t("admins.last_name") }}
                    </th>
                    <th class="sorting" v-if="columns.email.enabled">
                      {{ $t("admins.email") }}
                    </th>
                    <th class="sorting" v-if="columns.password.enabled">
                      {{ $t("admins.password") }}
                    </th>
                    <th class="sorting" v-if="columns.phone.enabled">
                      {{ $t("admins.phone") }}
                    </th>
                    <th class="sorting" v-if="columns.prefix.enabled">
                      {{ $t("admins.prefix") }}
                    </th>
                    <th class="sorting" v-if="columns.privleges.enabled">
                      {{ $t("admins.privileges") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_nases.enabled">
                      {{ $t("admins.allowed_nases") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_profiles.enabled">
                      {{ $t("admins.allowed_profiles") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.connection_status.enabled"
                    >
                      {{ $t("admins.connection_status") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('admins_view_search_admins')">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th
                      rowspan="1"
                      colspan="1"
                      style="border-left: none; width: 200px;"
                      v-if="columns.first_name.enabled"
                    >
                      <input
                        @input="applyFilters"
                        v-model="filters.first_name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      rowspan="1"
                      colspan="1"
                      style="border-left: none; width: 200px;"
                      v-if="columns.last_name.enabled"
                    >
                      <input
                        @input="applyFilters"
                        v-model="filters.last_name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      rowspan="1"
                      colspan="1"
                      style="border-left: none; width: 200px;"
                      v-if="columns.email.enabled"
                    >
                      <input
                        type="text"
                        @input="applyFilters"
                        v-model="filters.email"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.password.enabled"></th>
                    <th v-if="columns.phone.enabled"></th>
                    <th v-if="columns.prefix.enabled"></th>
                    <th v-if="columns.privleges.enabled"></th>
                    <th v-if="columns.allowed_nases.enabled"></th>
                    <th v-if="columns.allowed_profiles.enabled"></th>
                    <th v-if="columns.connection_status.enabled"></th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(admin, index) in dataList" :key="admin.id">
                    <td scope="row">
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('admins_edit_admins')">
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="showAddAdminDialog(admin)"
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('admins_edit_admins')">
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="showAddAdminDialog(admin, 'copy')"
                            >
                              <i class="ti ti-clipboard me-2"></i
                              >{{ $t("actions.copy") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('admins_delete_admins')">
                            <button
                              class="dropdown-item text-danger"
                              @click="deleteData(admin)"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="admin.selected"
                        @click="selectData(admin)"
                      />
                    </td>

                    <td>
                      <div
                        class="m-0 d-flex align-items-center avatar-group justify-content-center"
                      >
                        <div
                          class="pull-up"
                          style="width: 50px; cursor: pointer;"
                        >
                          <img
                            class="rounded-circle"
                            v-if="admin.profile_image"
                            :src="server_url + admin.profile_image"
                            alt="Avatar"
                          />
                        </div>
                      </div>
                    </td>
                    <td v-if="columns.first_name.enabled">
                      <a
                        v-if="hasPrivilege('admins_edit_admins')"
                        @click.prevent="showAddAdminDialog(admin)"
                        :href="`?admin_id=${admin.id}`"
                        >{{ admin.first_name }}</a
                      >
                      <div v-else>{{ admin.first_name }}</div>
                    </td>
                    <td v-if="columns.last_name.enabled">
                      {{ admin.last_name }}
                    </td>
                    <td v-if="columns.email.enabled">
                      <a
                        v-if="hasPrivilege('admins_edit_admins')"
                        @click.prevent="showAddAdminDialog(admin)"
                        :href="`?admin_id=${admin.id}`"
                        >{{ admin.email }}</a
                      >
                      <div v-else>{{ admin.email }}</div>
                    </td>
                    <td v-if="columns.password.enabled">
                      ********
                    </td>
                    <td v-if="columns.phone.enabled">{{ admin.phone }}</td>
                    <td v-if="columns.prefix.enabled">{{ admin.prefix }}</td>
                    <td v-if="columns.privleges.enabled">
                      <div
                        v-if="
                          admin.privileges_group_id == null &&
                            admin.privileges != null
                        "
                      >
                        <span class="badge bg-label-warning mb-1 me-1">{{
                          $t("groups.custom_privileges")
                        }}</span>
                      </div>
                      <div v-else>{{ admin.privileges_group_name }}</div>
                    </td>
                    <td v-if="columns.allowed_nases.enabled">
                      <div style="max-height: 50px; overflow-y: scroll;">
                        <span
                          v-for="nas in admin.allowed_nases"
                          :key="nas.id"
                          class="badge bg-label-primary mb-1 me-1"
                          >{{ nas.shortname }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.allowed_profiles.enabled">
                      <div style="max-height: 50px; overflow-y: scroll;">
                        <span
                          v-for="profile in admin.allowed_profiles"
                          :key="profile.id"
                          class="badge bg-label-primary mb-1 me-1"
                          >{{ profile.name }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.connection_status.enabled">
                      <span
                        v-if="admin.online"
                        class="badge bg-label-success me-1"
                        ><div>
                          {{ $t("control.online") }}
                        </div>
                        <div>
                          {{ admin.ip }}
                        </div></span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import { hasPrivilege } from "../global_constants.js";
import adminsAdd from "../components/modals/admins-add.vue";
export default {
  components: {
    adminsAdd,
  },
  name: "Admins",
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDisconnect: false,
      showDisable: false,
      showDeleteAll: false,
      showContext: false,
      loading: true,
      showFilters: false,
      fullList: false,
      showAddAdmin: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        phone: "",
        prefix: "",
        privleges: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        first_name: {
          name: this.$t("admins.first_name"),
          enabled: true,
          sort: false,
        },
        last_name: {
          name: this.$t("admins.last_name"),
          enabled: false,
          sort: false,
        },
        email: { name: this.$t("admins.email"), enabled: true, sort: false },
        password: {
          name: this.$t("admins.password"),
          enabled: false,
          sort: false,
        },
        phone: { name: this.$t("admins.phone"), enabled: false, sort: false },
        prefix: { name: this.$t("admins.prefix"), enabled: false, sort: false },
        privleges: {
          name: this.$t("admins.privileges"),
          enabled: false,
          sort: false,
        },
        allowed_nases: {
          name: this.$t("admins.allowed_nases"),
          enabled: false,
          sort: false,
        },
        allowed_profiles: {
          name: this.$t("nases.allowed_profiles"),
          enabled: true,
          sort: false,
        },
        connection_status: {
          name: this.$t("nases.connection_status"),
          enabled: true,
          sort: false,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      server_url: localStorage.getItem("server"),
    };
  },
  async created() {
    this.prepareFilters();
    this.prepareColumns();
    await this.fetchData();
    if (this.$route.query.admin_id) {
      this.showAddAdminDialog({ id: this.$route.query.admin_id });
    }
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get(`admins`);
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    async showAddAdminDialog(admin = null, operation = "new") {
      this.showAddAdmin = true;
      if (admin) {
        this.$router.push({
          query: { admin_id: admin.id, operation: operation },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-admins");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddAdmin = false;
      });
      modalInstance.show();
    },
    prepareFilters() {
      var filters = localStorage.getItem("admins_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("admins_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          first_name: {
            name: this.$t("admins.first_name"),
            enabled: cols[0].enabled,
            sort: false,
          },
          last_name: {
            name: this.$t("admins.last_name"),
            enabled: cols[1].enabled,
            sort: false,
          },
          email: {
            name: this.$t("admins.email"),
            enabled: cols[2].enabled,
            sort: false,
          },
          password: {
            name: this.$t("admins.password"),
            enabled: cols[3].enabled,
            sort: false,
          },
          phone: { name: this.$t("admins.phone"), enabled: cols[4].enabled },
          prefix: {
            name: this.$t("admins.prefix"),
            enabled: cols[5] != null ? cols[5].enabled : false,
          },
          privleges: {
            name: this.$t("admins.privileges"),
            enabled: cols[6] != null ? cols[6].enabled : false,
            sort: false,
          },
          allowed_nases: {
            name: this.$t("admins.allowed_nases"),
            enabled: cols[7] != null ? cols[7].enabled : false,
            sort: false,
          },
          allowed_profiles: {
            name: this.$t("admins.allowed_profiles"),
            enabled: cols[8] != null ? cols[8].enabled : true,
            sort: false,
          },
          connection_status: {
            name: this.$t("admins.connection_status"),
            enabled: cols[9] != null ? cols[9].enabled : true,
            sort: false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = `admins?filter=1`;
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.first_name != "")
        requestString += `&first_name=${this.filters.first_name}`;
      if (this.filters.last_name != "")
        requestString += `&last_name=${this.filters.last_name}`;
      if (this.filters.email != "")
        requestString += `&email=${this.filters.email}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        const response = await axios.get(requestString);
        this.dataList = response.data.data;
        if (this.filters.save)
          localStorage.setItem("admins_filters", JSON.stringify(this.filters));
        if (this.dataList.length < 1 && this.filters.page != 1) {
          this.filters.page = 1;
          this.applyFilters();
        }
        if (this.sort_col) {
          if (this.sort_dir == "ASC") {
            this.dataList.sort((a, b) =>
              a[this.sort_col] > b[this.sort_col]
                ? 1
                : b[this.sort_col] > a[this.sort_col]
                ? -1
                : 0
            );
          } else {
            this.dataList.sort((a, b) =>
              a[this.sort_col] < b[this.sort_col]
                ? 1
                : b[this.sort_col] < a[this.sort_col]
                ? -1
                : 0
            );
          }
        }
        this.meta = response.data.meta;
        this.loading = false;
      }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    editData(selectedData) {
      this.$router.push(`/admins/${selectedData.id}/edit`);
    },
    async deleteData(admin) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text:
          this.$t("admins.this_will_delete_admin_permanently") +
          " " +
          admin.email,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`admins/${admin.id}`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("admins.admin_deleted_successfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDelete() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "admins.this_will_delete_all_selected_admins_permanently"
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`admins/group`, {
              admins: this.selection_array,
            });
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("admins.selected_admins_have_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    openContextMenu(e, admin) {
      this.selectedData = admin;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns() {
      localStorage.setItem(
        "admins_columns",
        JSON.stringify(Object.values(this.columns))
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("admins_filters", JSON.stringify(this.filters));
    },
  },
};
</script>
